/*
  Deletes the cookie which has the name of 'cname' variable
*/

export function deleteCookie(cname) {
  document.cookie = `${cname}=; Max-Age=0; path=/;`;
}
